import { ApolloError } from '@apollo/client';
import { getErrorStatusCode, isBrowserOffline } from '@bloomays-lib/utils.shared';
import { Logger } from '../services/serviceLogger';

export const errorLogger = (
  error: Error,
  extra?: {
    state?: Record<string, unknown> | unknown;
    extraInfos: string;
    moduleName?: string;
  },
): void => {
  if (!error) return;
  const logger = Logger(extra?.moduleName);
  if (error instanceof ApolloError) {
    const { networkError, graphQLErrors } = error;
    if (graphQLErrors) {
      graphQLErrors.forEach((graphQLError, index) => {
        if (getErrorStatusCode(graphQLError) >= 500) {
          logger.error(
            `[GraphQL error #${index}] : Message: ${graphQLError.message}`,
            {
              ...extra,
              locations: graphQLError.locations,
              path: graphQLError.path,
              extensions: graphQLError.extensions,
            },
            error,
          );
        } else {
          logger.warn(`Message: ${graphQLError.message}`, {
            ...extra,
            locations: graphQLError.locations,
            path: graphQLError.path,
            extensions: graphQLError.extensions,
            error,
          });
        }
      });
    }

    if (networkError) {
      const offline = isBrowserOffline();
      const statusCode = getErrorStatusCode(networkError);
      const context = {
        ...extra,
        networkError,
        networkErrorName: networkError.name,
        networkErrorMessage: networkError.message,
        statusCode,
        offline,
      };
      // A network failure while the browser is offline is expected and should
      // not surface as an application error in Datadog logs (cf. TEC-1684).
      if (offline) {
        logger.warn(`[Network error - offline]: ${networkError}`, { ...context, error });
      } else {
        logger.error(`[Network error]: ${networkError}`, context, error);
      }
    }
    return;
  }

  logger.error(`[Unknown error]: , ${extra?.extraInfos || ''}`, extra, error);
};
